export default "__VITE_ASSET__Dy1L7wfp__"